export const getAddPayMethodFormContainerStyle = (theme) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%',
    maxWidth: '30rem'
});
